import { jwtDecode } from "jwt-decode";
import { accessRightsConfig } from "../access-rights/access-rights-config";
import { normalizeRolesFromClaim } from "../access-rights/user-roles";
export function decodeJwtUser(jwt) {
    const payload = jwtDecode(jwt);
    const claimName = accessRightsConfig.rolesClaimName;
    const rawRoles = payload[claimName];
    const roles = normalizeRolesFromClaim(rawRoles);
    return {
        name: payload.name,
        unique_name: payload.unique_name,
        roles,
    };
}
